module.exports = __webpack_public_path__ + "img/add-credit-card.31433012.svg";